import { render, staticRenderFns } from "./languageForm.vue?vue&type=template&id=5b08d7b7&scoped=true&"
import script from "./languageForm.vue?vue&type=script&lang=js&"
export * from "./languageForm.vue?vue&type=script&lang=js&"
import style0 from "./languageForm.vue?vue&type=style&index=0&id=5b08d7b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b08d7b7",
  null
  
)

export default component.exports